import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { orderedListSelector } from '@atlaskit/adf-schema';
import { getOrderedListInlineStyles } from '@atlaskit/editor-common/styles';
import { getItemCounterDigitsSize, resolveOrder } from '@atlaskit/editor-common/utils';
import { getListIndentLevel } from '../utils/lists';
export default function OrderedList(props) {
  var _props$content;
  var extraProps = {};
  var itemCounterDigitsSize = getItemCounterDigitsSize({
    order: props.order,
    itemsCount: props === null || props === void 0 || (_props$content = props.content) === null || _props$content === void 0 ? void 0 : _props$content.length
  });
  if (itemCounterDigitsSize && itemCounterDigitsSize > 2) {
    extraProps.style = getOrderedListInlineStyles(itemCounterDigitsSize, 'object');
  }
  if (props.order !== undefined) {
    extraProps.start = resolveOrder(props.order);
  }
  return /*#__PURE__*/React.createElement("ol", _extends({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className: orderedListSelector.substr(1),
    "data-indent-level": props.path ? getListIndentLevel(props.path) : 1,
    start: props.start
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, extraProps), props.children);
}